<!--FastBI产品-->
<template>
  <div class="xz_buyDialog">
    <el-dialog :before-close="cancel"
      :title="isAdd == 'triall' ? '客户试用' : isAdd == 'buy' || isAdd == 'module_buy' ? '增购模块' : '购买产品'"
      :visible.sync="visible" :close-on-click-modal="false" width="560px" :loading="dialog_loading">
      <el-form :model="form" ref="form" :rules="formRules">
        <el-form-item :label-width="formLabelWidth" :label="isAdd == 'buy' || isAdd == 'module_buy' ? '企业名称' : '授权企业名称'"
          prop="name">
          <el-input v-model="form.name" :disabled="isAdd == 'buy' || isAdd == 'module_buy'"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" :label="isAdd == 'buy' || isAdd == 'module_buy' ? '企业授权码' : '授权码'"
          prop="code">
          <el-input v-model="form.code" :disabled="isAdd == 'buy' || isAdd == 'module_buy'"></el-input>
        </el-form-item>
        <el-form-item v-if="isAdd != 'buy' && isAdd != 'module_buy'" :label-width="formLabelWidth" label="授权码密钥"
          prop="key">
          <el-input v-model="form.key"></el-input>
        </el-form-item>
        <el-form-item v-if="isAdd != 'buy' && isAdd != 'module_buy'" :label-width="formLabelWidth" label="联系人"
          prop="contact_name">
          <el-input v-model="form.contact_name" :disabled="isAdd == 'buy' || isAdd == 'module_buy'"></el-input>
        </el-form-item>
        <el-form-item v-if="isAdd != 'buy' && isAdd != 'module_buy'" :label-width="formLabelWidth" label="联系电话"
          prop="mobile">
          <el-input v-model="form.mobile" :disabled="isAdd == 'buy' || isAdd == 'module_buy'"></el-input>
        </el-form-item>

        <!-- <el-form-item v-if="isAdd != 'buy'" :label-width="formLabelWidth" label="选择版本" prop="af_edition">
          <el-select v-model="form.af_edition" placeholder="请选择">
            <el-option v-for="item in editions" :key="item.name" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item :label-width="formLabelWidth" label="选择应用" prop="main_apps">
          <el-select filterable v-model="form.main_apps" @change="selectApps" placeholder="请选择"
            :disabled="isAdd == 'module_buy'">
            <el-option v-for="item in apps" :key="item.name" :label="item.name" :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>


        <div v-if="isAdd != 'triall'">
          <el-form-item v-if="isAdd == 'buy'" :label-width="formLabelWidth" label="购买方式" prop="buy_type">
            <el-radio-group v-model="form.buy_type" @change="buy_type_change">
              <el-radio :label="1">买断模式</el-radio>
              <el-radio :label="2">按年订阅</el-radio>
              <el-radio :label="3">申请试用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-else :label-width="formLabelWidth" label="购买方式" prop="buy_type">
            <el-radio-group v-model="form.buy_type" @change="buy_type_change">
              <el-radio :label="1">买断模式</el-radio>
              <el-radio :label="2">按年订阅</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <el-form-item v-if="form.buy_type == 2" :label-width="formLabelWidth" label="购买时长">
          <template v-if="isAdd != 'triall'">
            <el-input-number style="text-align: center;" size="small" v-model="form.new_months" :min="1" :max="100"
              :step="1"></el-input-number>
            <span style="margin-left: 10px;">年</span>
          </template>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" v-if="form.buy_type == 3 && isAdd == 'buy'" :label="'试用时长'">
          <el-select v-model="form.trail_days" filterable placeholder="请选择">
            <el-option :key="7" label="七天" :value="7"> </el-option>
            <el-option :key="15" label="十五天" :value="15"> </el-option>
            <el-option :key="30" label="一个月" :value="30"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label-width="formLabelWidth" label="备注" prop="note">
          <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="form.note"> </el-input>
        </el-form-item>
        <!-- </div> -->
        <!-- <div v-if="isAdd != 'triall'">
          <el-form-item :label-width="formLabelWidth" label="支付方式" prop="pay_type">

            <el-radio-group v-model="form.pay_type">
              <el-radio :label="0">只用安捷云专用币</el-radio>
              <el-radio :label="1">安捷云专用币优先</el-radio>
              <el-radio :label="2">只用通用币</el-radio>
            </el-radio-group>
          </el-form-item>
        </div> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <div class="price">订单:<span>¥10000</span></div> -->
        <el-button @click="cancel('form')">取 消</el-button>
        <el-button v-if="isAdd == 'triall'" class="primary" @click="triallClick">申请试用</el-button>
        <el-button v-else-if="(isAdd == 'buy' && form.buy_type == 3)" class="primary"
          @click="triallModuleClick">申请试用</el-button>

        <el-button v-else class="primary" @click="buyClick">预览价格</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { getXZEditions } from '@/api/auth';

import { trailAFLocal, trailAFAppLocal, getAFAppsList, getAFEditionsList, localBuyPriceAuth, localBuyAuth, localBuyAppPriceAuth, localBuyAppAuth, localtrailAppAuth } from '@/api/afLocal';
import { checkAgentPrice } from '@/api/agent';
import { payType } from '@/utils/dataDict';
import { payVerify } from '@/utils/pay';
import { getVersionOption, getseriesNameOption, extractYearFromDates } from './utils';
export default {
  data() {
    return {
      dialog_loading: false,
      new_expire_time: '',
      modifyId: null,
      isAdd: 'add',
      currentBuyTime: null,
      payType,
      visible: false,
      formLabelWidth: '110px',
      form: {
        name: "", //企业名称
        code: "", //企业授权码
        key: "", //授权码密钥
        contact_name: "", //联系人
        months: "", //购买月数
        mobile: "", //联系电话
        pay_type: 1,    // 支付方式
        note: "",    // 备注
        // af_edition: '',   //版本
        main_apps: "",    // 应用
        buy_type: 1,
        new_months: 1,
        trail_days: 30
      },
      formRules: {
        name: [
          {
            required: true,
            message: '请输入授权企业名称',
            trigger: 'blur',
          },
        ],
        code: [
          {
            required: true,
            message: '请输入企业授权码',
            trigger: 'blur',
          },
        ],
        key: [
          {
            required: true,
            message: '请输入授权码密钥',
            trigger: 'blur',
          },
        ],
        contact_name: [
          {
            required: true,
            message: '请输入联系人',
            trigger: 'blur',
          },
        ],
        mobile: [
          {
            required: true,
            message: '请输入联系电话',
            trigger: 'blur',
          },
        ],
        main_apps: [
          {
            required: true,
            message: '请选择应用',
            trigger: 'blur',
          },
        ],
        // af_edition: [
        //   {
        //     required: true,
        //     message: '请输入版本',
        //     trigger: 'blur',
        //   },
        // ],

      },
      isSelectAll: false,
      apps: [],   //应用
      editions: [],   // 版本
      buyTime: [
        { name: '一年', value: 12 },
        { name: '两年', value: 24 },
        { name: '三年', value: 36 },
        { value: 1200, name: '买断', },
      ],
      orgLoading: false,
      periodsLoading: false
    };
  },
  mounted() {
    this.getAppsList();
    this.getEditionsList()
    this.getUserInfo();
  },
  methods: {
    getAppsList() {
      getAFAppsList().then(res => {
        console.log(res);

        this.apps = res
      }).catch(err => {

      })
    },
    getEditionsList() {
      getAFEditionsList().then(res => {
        this.editions = res
      })
    },

    selectApps(val) {

    },

    getUserInfo() {
      this.userInfo = this.$store.getters.userInfo;
    },


    formatDate(num) {
      let result = num + '';
      if (result.length < 2) {
        result = '0' + result;
      }
      return result;
    },
    show(obj) {

      this.buyTime = [
        { name: '一年', value: 12 },
        { name: '两年', value: 24 },
        { name: '三年', value: 36 },
        { value: 1200, name: '买断', },
      ];
      this.visible = true;
      if (this.isAdd == 'module_buy') {
        this.modifyId = obj.id;
        this.form.code = obj.code;
        this.form.key = obj.key;
        this.form.contact_name = obj.contact_name;
        this.form.mobile = obj.mobile;
        this.form.note = obj.note;
        this.form.name = obj.name;
        this.form.months = 12;
        this.form.pay_type = 1;
        this.form.main_apps = obj.main_apps;
      } else if (this.isAdd == 'buy') {
        this.modifyId = obj.id;
        this.form.code = obj.code;
        this.form.key = obj.key;
        this.form.contact_name = obj.contact_name;
        this.form.mobile = obj.mobile;
        this.form.note = obj.note;
        this.form.name = obj.name;
        this.form.months = 12;
        this.form.pay_type = 1;
        this.form.main_apps = "";
        // this.form.af_edition = "";

      } else if (this.isAdd == 'triall') {
        this.form.months = 1;
      } else if (this.isAdd == 'add') {
        this.form.months = 12;
      }
    },

    triallClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let obj = {}
          obj.name = this.form.name;
          obj.code = this.form.code;
          obj.mobile = this.form.mobile;
          if (this.isAdd == 'buy' && this.form.buy_type == 3) {
            obj.trail_days = this.form.trail_days || 30;
          } else {
            obj.trail_days = 30;   // 试用天数
          }

          obj.contact_name = this.form.contact_name;
          obj.note = this.form.note;
          obj.key = this.form.key;
          // obj.af_edition = this.form.af_edition;
          obj.main_apps = this.form.main_apps;
          trailAFLocal(obj)
            .then(() => {
              this.loading = false;
              this.$message({
                type: 'success',
                message: '申请试用成功',
              });
              this.resetForm();
              this.$parent.getAuthData();
              this.visible = false;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },

    triallModuleClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let obj = {}
          obj.auth_code = this.form.code;
          const selectedApp = this.apps.find(item => item.key === this.form.main_apps);
          
          obj.app = selectedApp.id || null;
          obj.trail_days = this.form.trail_days || 30
          trailAFAppLocal(obj)
            .then(() => {
              this.loading = false;
              this.$message({
                type: 'success',
                message: '申请试用成功',
              });
              this.resetForm();
              this.$parent.getAuthData();
              this.visible = false;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    resetForm() {
      this.form = {
        name: "", //企业名称
        code: "", //企业授权码
        key: "", //授权码密钥
        contact_name: "", //联系人
        months: "", //购买月数
        mobile: "", //联系电话
        pay_type: 1,
        note: "",
        af_edition: "",
        main_apps: "",
        buy_type: 1,
        new_months: 1,
        trail_days: 30
      };
    },
    buy_type_change(val) {
      // if (val == 2) {
      //   this.form.months = 1
      // }
    },
    buyClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let obj = {};
          let type = 1
          console.log(this.isAdd)
          let buyout = false
          if (this.form.buy_type == 1) {
            this.form.months = 1200
            buyout = true
          } else {
            this.form.months = Number(this.form.new_months) * 12
            buyout = false
          }
          if (this.isAdd == 'add') {

            obj = {
              months: this.form.months,
              pay_type: this.form.pay_type,
            };
            obj.name = this.form.name;
            obj.code = this.form.code;
            obj.key = this.form.key;
            obj.contact_name = this.form.contact_name;
            obj.note = this.form.note;
            obj.mobile = this.form.mobile;
            obj.name = this.form.name;
            // obj.af_edition = this.form.af_edition;
            obj.main_apps = this.form.main_apps;
            obj.buyout = buyout
            type = 1
          } else if (this.isAdd == 'buy' || this.isAdd == 'module_buy') {
            obj = {
              auth_code: this.form.code,
              app: this.form.main_apps,
              pay_type: this.form.pay_type,
              months: this.form.months,
            }
            obj.buyout = buyout

            type = 2
          }
          this.buySubmit(obj, type);

        }
      });
    },
    buySubmit(obj, type) {
      let priceObj = {};
      let method = null
      let priceMethod = null
      if (type == 1) {
        priceObj = {
          pay_type: obj.pay_type,
          main_apps: obj.main_apps,
          months: obj.months,
          buyout: obj.buyout,
          // af_edition: obj.af_edition,
        }
        method = localBuyAuth
        priceMethod = localBuyPriceAuth
      } else if (type == 2) {
        priceObj = obj
        method = localBuyAppAuth
        priceMethod = localBuyAppPriceAuth
      }

      priceMethod(priceObj)
        .then((res) => {
          this.$store
            .dispatch('user/userinfo') //获取账户余额
            .then(() => {
              this.loading = false;
              let finance = {
                special: this.$store.getters.userInfo.finance.af_point,
                universal: this.$store.getters.userInfo.finance.point,
              };

              let parms = {
                price: type == 1 ? res.total : res.price,
                payType: this.form.pay_type,
              };
              let result = payVerify(parms, finance); //检测余额是否足够
              this.$confirm(`${result.msg}，是否购买？`, '支付信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              })
                .then(() => {
                  method(Object.assign(obj, priceObj)).then((res) => {
                    this.$message({
                      type: 'success',
                      message: '购买成功!',
                    });
                    this.resetForm();
                    this.visible = false;
                    this.$parent.getAuthData();
                    if (this.isAdd == "module_buy") {
                      this.$parent.refreshAFOrdersApps();
                    }
                  });
                })
                .catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消购买',
                  });
                });
            });
        })
        .catch((err) => { });
    },
    modifyBuySubmit(obj) {
      let priceObj = {
        pay_type: this.form.pay_type,
        months: this.form.months,
      };
      addXZMonthPrice(this.modifyId, priceObj)
        .then((res) => {
          this.$store
            .dispatch('user/userinfo') //获取账户余额
            .then(() => {
              this.loading = false;
              let finance = {
                special: this.$store.getters.userInfo.finance.af_point,
                universal: this.$store.getters.userInfo.finance.point,
              };
              let parms = {
                price: res.price,
                payType: this.form.pay_type,
              };
              let result = payVerify(parms, finance); //检测余额是否足够
              this.$confirm(`${result.msg}，是否购买？`, '支付信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              })
                .then(() => {
                  addXZMonth(this.modifyId, obj).then((res) => {
                    this.$message({
                      type: 'success',
                      message: '购买成功!',
                    });
                    this.resetForm();
                    this.visible = false;
                    this.$parent.getAuthData();
                  });
                })
                .catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消购买',
                  });
                });
            });
        })
        .catch((err) => { });
    },
    cancel(formName, close) {
      this.visible = false;
      this.resetForm()
      setTimeout(() => {
        this.modifyId = null;
        this.isAdd = "add";
      }, 100);

    },





  },
};
</script>
<style lang="scss" scoped>
.xz_buyDialog {
  div {
    // box-sizing: border-box;
  }

  .input_bottom {
    margin-bottom: 10px;
  }

  /deep/ .el-dialog__body {
    padding: 30px 20px 0px 20px !important;
  }

  .ip_valid:before {
    content: '*';
    color: #f56c6c;
    margin-right: 4px;
  }

  .ip_main {
    .ip_input_main {
      display: inline-block;
      width: 100%;

      .add_span {
        width: 80px;
        text-align: center;
        color: #409eff;
        cursor: pointer;

        i {
          font-size: 20px;
        }
      }
    }
  }

  .ip_main :not(:last-child) {
    margin-bottom: 10px;
  }

  .info {
    margin: 10px 5px;
    border: 1px solid rgb(233, 233, 233);
    border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.047) 0px 0px 5px;

    .input_box {
      padding: 0 50px;
      margin-top: 20px;

      // margin-bottom: 10px;
      .block {
        display: inline-block;
        margin-right: 85px !important;
        margin-top: 0 !important;
        margin-bottom: 10px !important;
        width: 178px;

        .autocomplete {
          width: 100%;
        }

        .el-form-item {
          margin-bottom: 0px;
        }
      }

      .block:last-child {
        margin-right: 0 !important;
      }

      .label {
        margin-bottom: 5px;
        font-size: 13px;

        span {
          color: #ff0000;
        }
      }
    }

    .title {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      border-bottom: 1px solid rgb(233, 233, 233);
      font-size: 16px;
      font-weight: 650;
      padding: 15px 20px;
      background: #f9f9f9;
    }
  }

  .company_info {
    padding-bottom: 20px;
  }

  .authorization_info {
    .context {
      padding: 20px 50px;

      p {
        font-size: 13px;
        margin-bottom: 5px;
      }
    }
  }

  .pay_info {
    padding-bottom: 20px;
  }

  .price {
    float: left;
    text-align: left;
    font-size: 16px;

    span {
      color: #ff0000;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/agileFlow/buyLocal.vue